/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description:  Propulsion Technology component for Mission Operation view
Author: Deimos Space UK

Version: 1.0
*/
import React, { useState, useEffect } from 'react'
import { Row, Col, Form } from 'react-bootstrap';
import style from '../MissionOperation.module.css'
import Select from 'react-select';
export default function PropulsionTechnology(props) {
    const changePropulsionTechnology = (value) => {
        setPropulsionTechnology(value.value)
        props.onChangePropulsionTechnology(value, props.index)


    }

    const [propulsionTechnology, setPropulsionTechnology] = useState('')
    const [propulsionTechnologyData, setPropulsionTechnologyData] = useState('')
    useEffect(() => {
        if (props.step2 && props.step2[props.index] && props.step2[props.index].PropulsionTechnology) {
            setPropulsionTechnologyData(props.step2[props.index].PropulsionTechnology)
            setPropulsionTechnology(props.step2[props.index].PropulsionTechnology.propulsionTechnology.value)
        }

    }, [props])

    const getOptoonsPropulsionTechnology = () => {
        if (propulsionTechnology === 'chemical') {
            const chemical = [
                "Cold Gas",
                "Solid Motor",
                "Monopropellant",
                "Bipropellant 1",
                "Bipropellant 2",
                "Bipropellant 3",
                "Bipropellant 4",
                "Bipropellant 5",
                "Bipropellant 6",
                "Dual Mode",
                "Water Electrolysis",
                "Hybrid",
            ];
            return chemical.map((item, index) => {
                return { value: item, label: item }
            })



        } else if (propulsionTechnology === 'electrical') {
            const electrical = [
                "Ion 1 (T5)",
                "Ion 2 (Muses-C)",
                "Ion 3 (Melco)",
                "Ion 4 (FEEP)",
                "Ion 5 (SPT-70)",
                "Ion 6 (SPT-100)",
                "Arcjet 1 (1.8kW)",
                "Arcjet 2 (1.8kW)",
                "Resistojet 1",
                "Resistojet 2"
            ];

            return electrical.map((item, index) => {
                return { value: item, label: item }
            })
        }
    }

    const capitalize = (s) => {
        if(s?.label){
         return {value: s.value, label: s.label.charAt(0).toUpperCase() + s.label.slice(1)}
        }
        return s
     }

    return (
        <div style={{ marginTop: '20px' }}>
            <Row>
                <Col xs={12}>
                    <h4 style={{ color: '#003247' }}>Propulsion technology type</h4>
                </Col>
            </Row>
            <Form>
                <Row className={style.rowForm}>

                    <Col xs={6}>
                        <div style={{ color: '#003247' }}>Propulsion type </div>
                        <Select
                            isDisabled={props.disabled}
                            value={capitalize(propulsionTechnologyData.propulsionTechnology)}
                            className="react-select"
                            classNamePrefix="react-select"
                            onChange={(value) => {
                                changePropulsionTechnology(value)
                                if (value.value === 'chemical') {
                                    props.onChangePropulsionTechnologySubtype({value:'Monopropellant', label:'Monopropellant'}, props.index)
                                }else if(value.value === 'electrical'){
                                    props.onChangePropulsionTechnologySubtype({value:'Ion 1 (T5)', label:'Ion 1 (T5)'}, props.index)
                                }   
                            }}
                            options={[
                                { value: 'chemical', label: 'Chemical' },
                                { value: 'electrical', label: 'Electrical' },

                            ]}></Select>
                    </Col>
                    <Col xs={6}>
                        <div style={{ color: '#003247' }}>Propulsion technology </div>
                        <Select
                            isDisabled={props.disabled}
                            value={propulsionTechnologyData.propulsionTechnologySubtype}
                            className="react-select"
                            classNamePrefix="react-select"
                            onChange={e => props.onChangePropulsionTechnologySubtype(e, props.index)}
                            options={getOptoonsPropulsionTechnology()}></Select>

                    </Col>

                </Row>
                <Row className={style.rowForm}>
                    {(propulsionTechnology === 'chemical' || propulsionTechnology === 'electrical') &&
                        (
                            <Col xs={12} sm={4} style={{ marginTop: '10px' }}>
                                <Form.Group>
                                    <div style={{ color: '#003247' }}>Specific impulse [seconds] </div>
                                    <Form.Control
                                        placeholder='Optional'
                                        isInvalid={(isNaN(parseInt(propulsionTechnologyData.specificImpulse)) && propulsionTechnologyData.specificImpulse !== '') || parseInt(propulsionTechnologyData.specificImpulse) <= 0 || parseInt(propulsionTechnologyData.specificImpulse) >= 100000}
                                        disabled={props.disabled}
                                        value={propulsionTechnologyData.specificImpulse}
                                        onChange={e => props.onChangeSpecificImpulse(e.target.value, props.index)} type="text" />
                                </Form.Group>
                            </Col>
                        )
                    }
                    {propulsionTechnology === 'electrical' &&
                        (
                            <>
                                <Col xs={12} sm={4}>
                                    <Form.Group style={{ marginTop: '10px' }}>
                                        <div>Maximum thrust [mN] </div>
                                        <Form.Control
                                            placeholder='Optional'
                                            isInvalid={(isNaN(parseInt(propulsionTechnologyData.maximumThrust)) && propulsionTechnologyData.maximumThrust !== '') || parseInt(propulsionTechnologyData.maximumThrust) <= 0 || parseInt(propulsionTechnologyData.maximumThrust) >= 100000000}
                                            disabled={props.disabled}
                                            value={propulsionTechnologyData.maximumThrust}
                                            onChange={e => props.onChangeMaximumThrust(e.target.value, props.index)} type="text" />
                                    </Form.Group>
                                </Col>
                                <Col xs={12} sm={4}>
                                    <Form.Group style={{ marginTop: '10px' }}>
                                        <div>Thrust lifetime [hours] </div>
                                        <Form.Control
                                            placeholder='Optional'
                                            isInvalid={(isNaN(parseInt(propulsionTechnologyData.thrustLifetime)) && propulsionTechnologyData.thrustLifetime !== '') || parseInt(propulsionTechnologyData.thrustLifetime) <= 0 || parseInt(propulsionTechnologyData.thrustLifetime) >= 200000}
                                            disabled={props.disabled}
                                            value={propulsionTechnologyData.thrustLifetime}
                                            onChange={e => props.onChangeThrustLifetime(e.target.value, props.index)} type="text" />
                                    </Form.Group>
                                </Col>

                            </>
                        )
                    }

                    {propulsionTechnology === 'drag sail' &&
                        (
                            <>
                                <Col xs={6}>
                                    <Form.Group>
                                        <div> Effective sail area [m <sup>2</sup>] </div>
                                        <Form.Control
                                            disabled={props.disabled}
                                            isInvalid={(isNaN(parseInt(propulsionTechnologyData.effectiveSailArea)) && propulsionTechnologyData.effectiveSailArea !== '') || parseInt(propulsionTechnologyData.effectiveSailArea) <= 0}
                                            value={propulsionTechnologyData.effectiveSailArea}
                                            onChange={e => props.onChangeEffectiveSailArea(e.target.value, props.index)} type="text" />
                                    </Form.Group>
                                </Col>
                                <Col xs={6}>
                                    <Form.Group>
                                        <div>Mass [kg] </div>
                                        <Form.Control
                                            isInvalid={(isNaN(parseInt(propulsionTechnologyData.mass)) && propulsionTechnologyData.mass !== '') || parseInt(propulsionTechnologyData.mass) <= 0}
                                            disabled={props.disabled}
                                            value={propulsionTechnologyData.mass}
                                            onChange={e => props.onChangeMassPropulsion(e.target.value, props.index)} type="text" />
                                    </Form.Group>
                                </Col>

                            </>
                        )}
                </Row>
            </Form>
        </div>
    )
}
